export default __webpack_public_path__ + "static/media/b1.3b6d7994.jpg";